import { render, staticRenderFns } from "./SingleWard.vue?vue&type=template&id=42dbd3f3&"
import script from "./SingleWard.vue?vue&type=script&lang=js&"
export * from "./SingleWard.vue?vue&type=script&lang=js&"
import style0 from "./SingleWard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports